import { useState, useEffect } from 'react';
import axios from 'axios';
import { DIRECTUS_INSTANCE, fetchCurrentUser } from '../../../api';

/**
 * Hook to fetch and manage workspace token
 */
export const useWorkspaceToken = () => {
  const [widgetToken, setWidgetToken] = useState('');

  useEffect(() => {
    const fetchWorkspaceToken = async () => {
      try {
        const token = localStorage.getItem('directus_token');
        if (!token) {
          return;
        }

        // Get user's workspace ID
        const userData = await fetchCurrentUser(['linked_workspace.id']);
        const linkedWorkspaceId = userData?.linked_workspace?.id;
        
        if (linkedWorkspaceId) {
          // Get workspace data with widget_token
          const workspaceResponse = await axios.get(`${DIRECTUS_INSTANCE}/items/workspace/${linkedWorkspaceId}`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              fields: ['widget_token']
            }
          });
          
          if (workspaceResponse.data.data && workspaceResponse.data.data.widget_token) {
            setWidgetToken(workspaceResponse.data.data.widget_token);
          }
        }
      } catch (error) {
        // Silent error handling
      }
    };

    fetchWorkspaceToken();
  }, []);

  return widgetToken;
};

